<template>
  <div class="schemeB">
    <!-- 云币领取 -->
    <div class="receive" v-if="cloudData.type == 0">
      <div class="scheme-top">
        <img :src="cloudData.headUrl" alt="" class="scheme-img">
        <p>来自“{{cloudData.shopName}}”的红包</p>
      </div>
      <img src="../image/scheme-btn.gif" alt="" class="scheme-btn" @click="clickCloud()">
      <img src="../image/scheme-bottom.jpg" alt="" class="scheme-bottom">
    </div>
    <!-- 云币领取结果 -->
    <div class="result"  v-if="cloudData.type == 1 || cloudData.type == 2 || cloudData.type == 3">
      <div class="info">
        <!-- 领取成功 -->
        <div v-if="cloudData.type == 1">
          <img src="../image/bg-success.jpg" alt="" class="bg">
          <img src="../image/btn-success.gif" alt="" class="bg" @click="goMore()">
          <div class="title">
            <div>恭喜你获得</div>
            <i></i>
          </div>
          <div class="account" @click="goCouponList()">
            云币已放入{{cloudData.phone}}账户 查看 >
          </div>
          <div class="box">
            <div class="left">
              <div class="num">{{cloudData.couponValue}}</div>
              <div>云币</div>
            </div>
            <div class="right">
              <div>1云币=1RMB，购物可直接抵扣</div>
              <div class="date">有效期至：{{cloudData.endTime | formatNew}}</div>
            </div>
          </div>
        </div>
        <!-- 领取失败 -->
        <div v-if="cloudData.type == 2">
          <img src="../image/bg-error.jpg" alt="" class="bg">
          <img src="../image/btn-error.gif" alt="" class="bg" @click="goMore()">
          <img src="../image/error-icon.png" alt="" class="error-icon">
          <div class="error-test">手慢了，云币已抢完</div>
        </div>
        <div v-if="cloudData.type == 3" class="invalid">
          <img src="../image/bg-error.jpg" alt="" class="bg">
          <img src="../image/btn-error.gif" alt="" class="bg" @click="goMore()">
          <div>来晚了，云币已失效</div>
        </div>
      </div>
    </div>
    <!-- 推荐商品 -->
    <RecommendB ref="recommend"/>
  </div>
</template>

<script type="text/ecmascript-6">
import Vue from 'vue'
import { Toast } from 'mint-ui'
import CommoditiesList from '@/pages/commodity/components/CommoditiesList'
import YunJi from '@/assets/js/YunJi'
import ShareError from '@/pages/commodity/components/ShareError'
import * as Http from '@/pages/commodity/api/share'
import * as yunjiysHttp from '@/pages/commodity/api/commodityList'
import * as Util from '@/assets/js/Util'
import { InfiniteScroll } from 'mint-ui';
import RecommendB from './RecommendB.vue'


Vue.use(InfiniteScroll);

export default {
  name: 'scheme-receive-b',
  data() {
    return {
      select: true,
      seqId: YunJi.getUrlParams('seqId') || '',
      shareConsumerId: YunJi.getUrlParams('shareConsumerId') || '',
      appCont: YunJi.getUrlParams('appCont') || 0,
      ticket: YunJi.getUrlParams('ticket'),
      shopId: YunJi.getUrlParams('shopId'), // 获取店铺id,
      vComit: true,
    }
  },
  filters: {
    formatNew(value) {
      return YunJi.formatNew(value, "yyyy.MM.dd");
    }
  },
  props: {
    cloudData: { // 基本信息
      type: Object,
      default() {
        return {}
      }
    }
  },
  components: { 
    CommoditiesList,
    RecommendB
  },
  activated() {},
  mounted() {
    this.$nextTick(() => {
      console.log(this.cloudData)
    })
  },
  methods: {
    // 点击领取云币
    clickCloud() {
      if (!this.vComit) return
      this.vComit = false // 防止重复提交
      const params = {
        seqId: this.seqId,
        shopId: this.shopId,
        shareConsumerId: this.shareConsumerId,
        appCont: this.appCont,
        ticket: this.ticket
      }
      Http.getClickCouponShare(params).then((res) => {
        if (res.errorCode === parseFloat(Util.ERR_CODE) && res.data) {
          this.cloudData = res.data
          this.$refs.recommend.initList();
          this.$refs.recommend.queryCouponFunc();
        } else {
          Toast(res.errorMessage)
          this.vComit = true
        }
      }).catch(() => {
        this.vComit = true
        Toast('网络错误')
      })
    },
    // 跳首页
    goMore() {
      // 埋点
      // window.thinkingReport.track('others', {
      //   page_id: '00065',
      //   point_id: this.cloudData.type === 1 ? '21548' : '21550',
      //   ABtestId: this.personalItem.aBtestId,
      //   business_state: this.cloudData.type === 1 ? '领取成功' : this.cloudData.type === 2 ? '已抢完' : '已失效',
      // })
      if (Util.isWxProgram()) {
        wx.miniProgram.switchTab({ url: '/pages/index/index'})
      }
    },
    // 跳云币列表
    goCouponList() {
      // 埋点
      // window.thinkingReport.track('others', {
      //   page_id: '00065',
      //   point_id: '21547',
      //   ABtestId: this.personalItem.aBtestId,
      //   business_state: this.cloudData.type === 1 ? '领取成功' : this.cloudData.type === 2 ? '已抢完' : '已失效',
      // })
      if (Util.isWxProgram()) {
        wx.miniProgram.navigateTo({ url: `/pages/cloudcoin-list/cloudcoin-list?shopId=${this.shopId}&from=wo` })
      }
    }
  }
}
</script>

<style lang="less" scoped>
  .schemeB {
    min-height: 100vh;
    background: #FFF3F4;
    .receive{
      box-sizing: border-box;
      position: absolute;
      z-index: 3;
      top: 0;
      left: 0;
      margin: 0 auto;
      width: 100%;
      height: 100%;
      overflow-y: auto;
      text-align: center;
      .scheme-top {
        width: 1005;
        height: 4.14rem;
        background: url('../image/scheme-top.jpg') no-repeat; 
        background-size: 100% 100%;
        .scheme-img {
          margin-top: .5rem;
          width: 1.16rem;
          height: 1.16rem;
          border-radius: 50%;
          border: .06rem solid #fff;
        }
        p{
          font-size: 0.3rem;
          color: #FFFFFF;
          margin-top: 0.2rem;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
      }
      .scheme-btn,.scheme-bottom{
        width: 100%;
        vertical-align: top;
      }
      
    }
    .result{
      padding-bottom: 0.4rem;
      .info{
        position: relative;
        height: 7rem;
        .bg{
          width: 100%;
          vertical-align: top;
        }
        .title{
          position: absolute;
          top: 1.1rem;
          left: 0;
          width: 100%;
          height: 0.6rem;
          i{
            display: inline-block;
            width: 2.46rem;
            height: 0.24rem;
            background: #FFEC6C;
            border-radius: 0.12rem;
            position: absolute;
            bottom: 0.12rem;
            left: 50%;
            transform: translate(-50%,0);
          }
          div{
            font-size: 0.44rem;
            color: #FF0015;
            font-weight: bold;
            position: absolute;
            top: 0;
            left: 50%;
            transform: translate(-50%,0);
            z-index: 1;
          }
        }
        .account{
          font-size: 0.22rem;
          color: #DAAA61;
          position: absolute;
          top: 1.85rem;
          left: 0;
          width: 100%;
          text-align: center;
        }
        .box{
          width: 5.72rem;
          height: 1.49rem;
          background: #FFF0DA;
          border: 1px solid #FFEAC8;
          box-shadow: 0 1px 0 0 #FFF8ED;
          border-radius: 0.16rem;
          position: absolute;
          top: 2.43rem;
          left: 50%;
          transform: translate(-50%,0);
          display: flex;
          .left{
            width: 1.8rem;
            text-align: center;
            color: #DAAA61;
            font-size: 0.3rem;
            .num{
              font-size: 0.5rem;
              margin: 0.32rem 0 0.2rem;
            }
          }
          .right{
            flex: 1;
            font-size: 0.22rem;
            color: #333333;
            padding-top: 0.32rem;
            .date{
              color: #92918D;
              margin-top: 0.16rem;
            }
          }
        }
        .error-icon{
          position: absolute;
          top: 1.1rem;
          left: 50%;
          transform: translate(-50%,0);
          width: 1.8rem;
        }
        .error-test{
          position: absolute;
          top: 3.25rem;
          left: 0;
          font-size: 0.42rem;
          color: #FF0015;
          width: 100%;
          text-align: center;
          font-weight: bold;
        }
        .invalid{
          div{
            position: absolute;
            top: 2.1rem;
            left: 50%;
            transform: translate(-50%,0);
            width: 5.72rem;
            height: 1.49rem;
            background: #FFF0DA;
            font-size: 21px;
            color: #DAAA61;
            display: flex;
            align-items: center;
            justify-content: center;
            font-weight: bold;
          }
        }
      }
    }
  }
</style>
